import { ERROR_MESSAGES_OPEN_MODAL } from './constants.helper';

function errorMessage(message) {
  return ERROR_MESSAGES_OPEN_MODAL.some((msg) => message.includes(msg));
}

export { errorMessage };
